import { HttpClient, HttpErrorResponse, HttpResponse } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable, throwError } from "rxjs";
import { catchError, map } from "rxjs/operators";
import { ClientForm } from '../../../models/client-form/client-form.model';
import { ClientFormsSerializer } from '../../../models/client-form/client-form-serializer.class';
import { BaseApiService } from "../base/base-api.service";
import { CustomErrorHandlerService } from '../custom-error-handler.service';

/**
 * Service to communicate with API Client Users
 */

@Injectable()
export class ClientFormsService extends BaseApiService<ClientForm> {
  private static readonly ENDPOINT: string = "forms";

  constructor(httpClient: HttpClient) {
    super(
        httpClient,
        null,
        ClientFormsService.ENDPOINT,
        new ClientFormsSerializer(),
        new CustomErrorHandlerService());
  }

  /**
   * BUG-073: deleting a form succeeded on the server, yet the screen said
   * "An error occurred. Please try again." and kept the row.
   *
   * DELETE v1/forms/{id} answers 200 with the bare string "Deleted Successfully"
   * (ClientFormController.Delete), which ASP.NET Core's default StringOutputFormatter
   * writes as text/plain. The inherited delete() leaves responseType at its 'json'
   * default, so Angular's XHR backend runs JSON.parse("Deleted Successfully"); the parse
   * throws, and because the status was 2xx Angular flips `ok` to false and delivers an
   * HttpErrorResponse whose status is 200. The success callback therefore never runs even
   * though the form is already gone.
   *
   * Reading the response as text skips that parse entirely, so every successful delete
   * stays on the success channel: a bare-string body, a JSON body and an empty 204 all
   * resolve. Real failures are still non-2xx and still reach the error channel with the
   * body intact for AppHttpInterceptor to report.
   *
   * Overridden here instead of in BaseApiService, which 50+ services share.
   */
  public override delete(id: string): Observable<string> {
    return this.httpClient
      .delete(`${this.url}/${ClientFormsService.ENDPOINT}/${id}`, {
        observe: 'response',
        responseType: 'text'
      })
      .pipe(
        map((response: HttpResponse<string>): string => response.body ?? ''),
        catchError((httpError: HttpErrorResponse): Observable<never> =>
          throwError((): HttpErrorResponse => httpError))
      );
  }
}
